import styled from 'styled-components';
import { LabelMixin } from '../../mixins/components/LabelMixin';
export var StyledLabel = /*#__PURE__*/styled.label.withConfig({
  displayName: "StyledLabel",
  componentId: "c11n-8-107-0__sc-14wqmdp-0"
})(["", ""], LabelMixin);